import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IPrefmanceTrend } from "../../../Pages/DashboardUserStudent/IDashboardUserStudent";

export const ListPrefmanceTrendSlice = createSlice({
  name: "ListPrefmanceTrendSlice",
  initialState: {} as IReduxState<IPrefmanceTrend[]>,
  reducers: {
    listPrefmanceTrend: (state, _: PayloadAction<IPrefmanceTrend>) => {
      state.isLoading = true;
    },
    successlistPrefmanceTrend: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistPrefmanceTrend: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistPrefmanceTrend,
  listPrefmanceTrend,
  successlistPrefmanceTrend,
} = ListPrefmanceTrendSlice.actions;

export default ListPrefmanceTrendSlice.reducer;
